// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { ni16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-ni': IconNi;
    }
}

/**
 * The icon component for the 'ni' icon
 */
export class IconNi extends IconSvg {
    public constructor() {
        super(ni16X16);
    }
}

registerIconSvg('icon-ni', IconNi);
export const iconNiTag = 'nimble-icon-ni';
